import { useCallback, useState } from 'react';
import type { ShipmentTab } from '@/pages/Shipments/ControlTower/types';

export const useViewFiltersModal = () => {
  const [viewFiltersTab, setViewFiltersTab] = useState<ShipmentTab | null>(
    null
  );
  const [viewFiltersModalOpen, setViewFiltersModalOpen] = useState(false);

  const handleOpenViewFiltersModal = useCallback((tab: ShipmentTab) => {
    setViewFiltersTab(tab);
    setViewFiltersModalOpen(true);
  }, []);

  const handleCloseViewFiltersModal = useCallback(() => {
    setViewFiltersModalOpen(false);
    setViewFiltersTab(null);
  }, []);

  return {
    viewFiltersTab,
    viewFiltersModalOpen,
    handleOpenViewFiltersModal,
    handleCloseViewFiltersModal,
  };
};

export default useViewFiltersModal;
